import { Refresh } from "@mui/icons-material";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { useState } from "react";

import { useSetWorkStateMutation } from "../../store/services/crmApi";
import { Work, WorkStateEnum } from "../../store/types/work.types";

interface ReopenWorkButtonProps {
  work: Work;
  onReopen?: () => void;
}

const ReopenWorkButton = ({ work, onReopen }: ReopenWorkButtonProps) => {
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [setWorkState, { isLoading }] = useSetWorkStateMutation();

  // Check if work is already open or not set
  if (work.State === WorkStateEnum.Open || work.State === WorkStateEnum.NotSet) {
    return null;
  }

  const handleClick = () => {
    setConfirmDialogOpen(true);
  };

  const handleReopenWork = async () => {
    try {
      await setWorkState({
        workId: work.Id,
        workState: WorkStateEnum.Open
      }).unwrap();

      setConfirmDialogOpen(false);
      onReopen?.();
    } catch (error) {
      // Error is handled by the mutation with toast
      console.error("Failed to reopen work:", error);
    }
  };

  const getStateText = (state: WorkStateEnum) => {
    switch (state) {
      case WorkStateEnum.Closed:
        return "stängt";
      case WorkStateEnum.Solved:
        return "löst";
      default:
        return "avslutat";
    }
  };

  return (
    <>
      <Button
        onClick={handleClick}
        variant="outlined"
        color="primary"
        size="large"
        startIcon={<Refresh />}
        disabled={isLoading}
        sx={{ borderRadius: 2 }}
      >
        Återöppna ärende
      </Button>

      <Dialog
        open={confirmDialogOpen}
        onClose={() => setConfirmDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          Bekräfta återöppning
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Ärendet är för närvarande {getStateText(work.State)}.
            <br /><br />
            Är du säker på att du vill återöppna ärendet "{work.Name}"?
            <br /><br />
            Detta kommer att sätta ärendets status tillbaka till "Öppen" så att du kan fortsätta arbeta med det.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setConfirmDialogOpen(false)}
            disabled={isLoading}
          >
            Avbryt
          </Button>
          <Button
            onClick={handleReopenWork}
            color="primary"
            variant="contained"
            disabled={isLoading}
          >
            Ja, återöppna
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ReopenWorkButton;